var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1387 12.8193C20.2027 10.2819 23.7979 10.2819 24.8618 12.8193L26.338 16.3398L30.1387 16.6421C32.897 16.8614 34.0105 20.3082 31.9019 22.0999L29.0249 24.5445L29.9083 28.2181C30.553 30.8991 27.6418 33.0263 25.2834 31.5974L22.0003 29.6082L18.7171 31.5974C16.3588 33.0263 13.4476 30.8991 14.0923 28.2181L14.9757 24.5445L12.0986 22.0999C9.99002 20.3082 11.1036 16.8614 13.8618 16.6421L17.6625 16.3398L19.1387 12.8193ZM22.6606 13.7423C22.4151 13.1567 21.5854 13.1567 21.3399 13.7423L19.8075 17.3969C19.4967 18.1382 18.798 18.644 17.9967 18.7077L14.0511 19.0215C13.4145 19.0721 13.1576 19.8675 13.6442 20.2809L16.633 22.8206C17.2503 23.3451 17.5201 24.1723 17.3307 24.9599L16.413 28.7762C16.2642 29.3948 16.936 29.8857 17.4802 29.556L20.8871 27.4919C21.5713 27.0773 22.4292 27.0773 23.1134 27.4919L26.5203 29.556C27.0645 29.8857 27.7363 29.3948 27.5876 28.7762L26.6698 24.9599C26.4804 24.1723 26.7502 23.3451 27.3675 22.8206L30.3564 20.2809C30.843 19.8675 30.586 19.0721 29.9495 19.0215L26.0038 18.7077C25.2025 18.644 24.5038 18.1382 24.193 17.3969L22.6606 13.7423Z",
    fill: "#8888B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.21cd4fa9.svg";
export { ForwardRef as ReactComponent };